import { FastField } from 'formik';
import React from 'react';
import styles from './radio-group.module.css';
import { validateRadio } from '~/common/util/customValidation';

interface RadioFieldGroupProps {
  label: string;
  name: string;
  options: { [key: string]: string }[];
  error: string;
  errorMessage: string;
  onFocus: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const RadioFieldGroup = ({
  name,
  options,
  label,
  error,
  errorMessage,
  onFocus,
  onChange,
  onBlur,
}: RadioFieldGroupProps) => {
  const labelId = `${name}-label`;
  const errorId = `${name}-error`;
  return (
    <div>
      <fieldset
        className={styles.wrapper}
        role="radiogroup"
        aria-labelledby={labelId}
        aria-required="true"
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? errorId : undefined}
      >
        <label id={labelId} className={styles.label}>
          {label}
        </label>
        <div className={styles.buttons}>
          <FastField name={name} validate={validateRadio}>
            {({ field }: { field: any }) => {
              return options.map((option) => {
                const fieldName = Object.keys(option)[0] as string;
                return (
                  <label className={styles.radio}>
                    <input
                      type={'radio'}
                      name={name}
                      id={fieldName}
                      {...field}
                      value={fieldName}
                      checked={field.value === fieldName}
                      onFocus={onFocus}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        field.onChange(event);
                        onChange?.(event);
                      }}
                      onBlur={(event: React.FocusEvent<HTMLInputElement>) => onBlur(event)}
                    />
                    <div className={styles.radioButton}>&nbsp;</div>
                    {fieldName}
                  </label>
                );
              });
            }}
          </FastField>
        </div>
        {error && (
          <div id={errorId} className={styles.errorMessage}>
            {errorMessage}
          </div>
        )}
      </fieldset>
    </div>
  );
};
